import React, { FC, Fragment } from 'react';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import { useTranslation } from 'react-i18next';
import { CONSTANTS } from 'config/constants';
import DHDialog from 'components/shared/dh-dialog/dh-dialog.component';
import Box from '@mui/material/Box';

type AddConstructionPropertyProps = {
    handleClose: () => void;
    open: boolean;
    handlePropertySelection: (selectedProperty: string) => void;
};
const AddConstructionProperty: FC<AddConstructionPropertyProps> = ({
    open,
    handleClose,
    handlePropertySelection,
}: AddConstructionPropertyProps) => {
    const { t: translate } = useTranslation(['order', 'construction-props']);
    const [selectedProperty, setSelectedProperty] = React.useState('');

    const handleChange = (event: SelectChangeEvent<string>) => {
        setSelectedProperty(event.target.value);
    };

    const addProperty = () => {
        handlePropertySelection(selectedProperty);
        setSelectedProperty('');
    };

    return (
        <Fragment>
            <DHDialog
                fullWidth
                open={open}
                onClose={handleClose}
                title={translate('orders:ADD_CONSTRUCTION_PROPERTY')}
                actions={
                    <Button disabled={!selectedProperty} variant="contained" onClick={addProperty} autoFocus>
                        {translate('orders:ADD_CONSTRUCTION_PROPERTY')}
                    </Button>
                }
            >
                <Box mt={1}>
                    <FormControl fullWidth>
                        <InputLabel id="property-select-label">{translate('orders:PROPERTY')}</InputLabel>
                        <Select
                            labelId="property-select-label"
                            id="property-select"
                            value={selectedProperty}
                            onChange={handleChange}
                            label={translate('orders:PROPERTY')}
                        >
                            {Object.keys(CONSTANTS.PROPERTY).map((key: string, index: number) => {
                                return (
                                    <MenuItem key={index} value={key}>
                                        {translate(`construction-props:${key}`)}
                                    </MenuItem>
                                );
                            })}
                        </Select>
                    </FormControl>
                </Box>
            </DHDialog>
        </Fragment>
    );
};

export default AddConstructionProperty;
